// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  AssetCategory,
} from "./types";


export default __t.row({
  renditionId: __t.u64().primaryKey().name("rendition_id"),
  assetId: __t.u64().name("asset_id"),
  format: __t.string(),
  get category() {
    return AssetCategory;
  },
  boundsMinX: __t.option(__t.f64()).name("bounds_min_x"),
  boundsMinY: __t.option(__t.f64()).name("bounds_min_y"),
  boundsMinZ: __t.option(__t.f64()).name("bounds_min_z"),
  boundsMaxX: __t.option(__t.f64()).name("bounds_max_x"),
  boundsMaxY: __t.option(__t.f64()).name("bounds_max_y"),
  boundsMaxZ: __t.option(__t.f64()).name("bounds_max_z"),
  currentVersionId: __t.option(__t.u64()).name("current_version_id"),
  sourceRenditionId: __t.option(__t.u64()).name("source_rendition_id"),
  createdAt: __t.timestamp().name("created_at"),
  correctionOffsetX: __t.f64().name("correction_offset_x"),
  correctionOffsetY: __t.f64().name("correction_offset_y"),
  correctionOffsetZ: __t.f64().name("correction_offset_z"),
  correctionYawDeg: __t.f64().name("correction_yaw_deg"),
  correctionPitchDeg: __t.f64().name("correction_pitch_deg"),
  correctionRollDeg: __t.f64().name("correction_roll_deg"),
  correctionScaleX: __t.f64().name("correction_scale_x"),
  correctionScaleY: __t.f64().name("correction_scale_y"),
  correctionScaleZ: __t.f64().name("correction_scale_z"),
  geoOriginLon: __t.option(__t.f64()).name("geo_origin_lon"),
  geoOriginLat: __t.option(__t.f64()).name("geo_origin_lat"),
  geoOriginAlt: __t.option(__t.f64()).name("geo_origin_alt"),
  geoHeadingDeg: __t.option(__t.f64()).name("geo_heading_deg"),
  footprintGeojson: __t.option(__t.string()).name("footprint_geojson"),
});
